export default __webpack_public_path__ + "static/media/tree24.5391d440.png";